import React from 'react';
import { Button } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAnalytics, logEvent } from 'firebase/analytics';

import useParseMarkdown from "../hooks/useParseMarkdown";
import useLangParam from '../hooks/useLangParam';
import CourseModel from '../models/CourseModel';
import Layout from './Layout';
import Header from '../components/Header';
import NotFound from '../components/NotFound';
import Loader from '../components/Loader';
import NetworkError from '../components/NetworkError';

function Course() {
  useLangParam();
  const parseMarkdown = useParseMarkdown();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { courseSlug } = useParams();
  const {
    course,
    isLoading,
    isError,
    refetch,
  } = CourseModel();

  function doneAction() {
    logEvent(getAnalytics(), 'complete_course_intro', {
      course: courseSlug
    });
    if (course && course.lessons && course.lessons.length) {
      const lesson = course.lessons[0];
      navigate(`${lesson.id}-${lesson.slug}`);
    }
  }

  if (isLoading) {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }
  if (isError) {
    return (
      <Layout>
        <NetworkError onRefresh={refetch} />
      </Layout>
    )
  }
  if (course && course.name) {
    return (
      <Layout>
        <Header title={course.name} subtitle={course.subtitle} />

        <div
          className="course-description"
          style={{ paddingInline: '1rem' }}
          dangerouslySetInnerHTML={{
            __html: parseMarkdown(course.description)
          }}
        />

        <div className="done-button">
          <Button
            onClick={doneAction}
            variant="contained"
          >
            {t('lesson.goToFirstLesson')}
          </Button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <NotFound />
    </Layout>
  );
}

export default Course;
